import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    Collapse,
    Modal,
    OverlayTrigger,
    Table,
    Tooltip,
} from "react-bootstrap";
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import AddUserByAdmin from "../addUserByAdmin/addUserByAdmin";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { allFeedbackList } from "../../service/api/user/allFeedbackList";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { getFeedbackById } from "../../service/api/user/getFeedbackById";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import { lblEmail, lblPhoneNumber, txtAction, txtCreatedDate, txtFeedbackList, txtFullName, txtNoRecordsFound, txtRole } from "../../dataBaseFile/label";
import InternationalPhoneFormatFun from "../../ui/InternationalPhoneFormatFun";
import { apiGetRegisteredCompanies } from "../../service/api/companies/getRegisteredCompanies";
import deleteCompanyApi from "../../service/api/companies/deleteCompany";
// import CompanyDetails from "./companyDetails";
import { FaSearch } from "react-icons/fa";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { getRefundListViaStatusApi } from "../../service/api/paymentGateway/getRefundListViaStatus";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import { createRefundApi } from "../../service/api/paymentGateway/createRefund";
import { getPaymentConfigApi } from "../../service/api/paymentGateway/getPaymentConfig";
import SelectPeriodFilter from "../../jsx/components/fields/selectPeriodFilter";
const Refunds = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Toggle for the refund elements
    const [toggleRefundTabs, setToggleRefundTabs] = useState(1);
    const [refundListLoading, setRefundListLoading] = useState(false);
    const [refundList, setRefundList] = useState([]);
    const [refundObj, setRefundObj] = useState({});

    const [responseMsg, setResponseMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);

    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [elements, setElements] = useState([]);

    const [sortByValue, setSortByValue] = useState("DESC");
    const [columnName, setColumnName] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [flag, setFlag] = useState(false);

    const [skeltonVal, setSkeltonVal] = useState(false);
    const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);
    const [sortingCol, setSortingCol] = useState(true);
    const [isExpandedCallLogId, setIsExpandedCallLogId] = useState('');

    const [periodFilter, setPeriodFilter] = useState('');
    const periodArr = [
        { id: "WEEK", name: "Last week" },
        { id: "MONTH", name: "Last month" },
        { id: "QUARTER", name: "Last quarter" },
        { id: "YEAR", name: "Last year" },
        { id: "ALL", name: "ALL" },
    ]

    const handlePeriodFilter = (e) => {
        setPeriodFilter(e.target.value);
    }


    // Functions for the refund elements
    const GetRefundListViaStatusFn = () => {
        setRefundListLoading(true);
        setCustomeSkeletonLoading(true);
        // let details = {
        //     status: toggleRefundTabs,
        // }
        let details = new FormData();
        details.append("status", toggleRefundTabs);
        details.append("current_date", Math.floor(Date.now() / 1000));
        details.append("filter_type", periodFilter === 'ALL' ? '' : periodFilter);
        details.append("page_index", page);
        details.append("page_size", pageSize);
        details.append("sorting_order", sortByValue)
        details.append("sorting_column_name", columnName);
        details.append("search_area", searchValue);

        dispatch(
            getRefundListViaStatusApi(details,
                (res) => {
                    // console.log(res.data.data, "refund list")
                    setRefundListLoading(false);
                    setCustomeSkeletonLoading(false);
                    // setRefundList(res.data.data);
                    getCallHistoryDetails(res.data);
                },
                (res) => {
                    console.log(res)
                    setRefundListLoading(false);
                    setCustomeSkeletonLoading(false);
                })
        )
    }

    function onLoadSearch() {
        setSkeltonVal(true);

        let details = new FormData();
        details.append("status", toggleRefundTabs);
        details.append("current_date", Math.floor(Date.now() / 1000));
        details.append("filter_type", periodFilter === 'ALL' ? '' : periodFilter);
        details.append("page_index", 1);
        details.append("page_size", pageSize);
        details.append("sorting_order", sortByValue)
        details.append("sorting_column_name", columnName);
        details.append("search_area", searchValue);

        dispatch(
            getRefundListViaStatusApi(details, (res) => {
                getCallHistoryDetails(res.data);
                // setElements(res.data.data);
                // setTotalNoRecord(res.data.total_count);
                // if (res.data.total_count % pageSize === 0) {
                //   setTotalPage(parseInt(res.data.total_count / pageSize));
                // } else {
                //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
                // }

                if (res.data.data.length === 0) {
                    setTimeout(() => {
                        setSkeltonVal(true);
                    }, "3000");
                } else {
                    setSkeltonVal(true);
                }
            })
        );
    }

    const getCallHistoryDetails = (res) => {

        // const newElements = [...elements, ...res.data];
        // const uniqueElements = Array.from(
        //   new Set(newElements.map(JSON.stringify))
        // ).map(JSON.parse);


        setElements(res.data);
        setTotalNoRecord(res.total_count);

        if (res.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.total_count / pageSize));
        } else {
            setTotalPage(parseInt(res.total_count / pageSize + 1));
        }

        if (res.total_count === 0) {
            setTimeout(() => {
                setSkeltonVal(true);
            }, "3000");
        } else {
            setSkeltonVal(true);
        }

        // console.log(parseInt(res.total_records / pageSize), 'quoitent')
    };

    useEffect(() => {
        // setRefundList([]);
        GetRefundListViaStatusFn()
    }, [toggleRefundTabs, sortByValue, pageSize, page, columnName, periodFilter])

    // Format the price to USD 
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    // Functions to approve the refunds 
    const [approveRefundModalTrigger, setApproveRefundModalTrigger] = useState(false);
    const [approveRefundLoading, setApproveRefundLoading] = useState(false);
    const handleOpneApproveRefundModal = (element) => {
        setRefundObj(element);
        setApproveRefundModalTrigger(true);
    }
    const handleCloseApproveRefundModal = () => {
        setApproveRefundModalTrigger(false);
        setRefundObj({});
    }




    const handleApproveRefund = () => {
        setApproveRefundLoading(true);

        let transferId = '';
        if (Object?.keys(refundObj)?.length !== 0) {
            refundObj?.transfer_data?.map((ele) => {
                if (ele?.is_sent_to_pro) transferId = ele?.id
            })
        }

        let details = new FormData();

        details.append("user_id_ids", localStorage.getItem("user_id"));
        details.append("payment_intent_id_ids", refundObj?.payment_intent_id_chr);
        // details.append("refund_amount_in_cents", (paymentConfigObj?.service_charge_percentage_float * paymentConfigObj?.call_charge_amount_in_cents_int));
        details.append("refund_amount_in_cents", (refundObj?.meta_data?.object == "payment_intent" ? refundObj?.meta_data?.amount : 0));
        // details.append("transfer_id_ids", transferId);
        details.append("call_log_id_ids", refundObj?.call_log_id_lng);
        details.append("refund_flag", 1);
        // details.append("reversal_flag", 1);
        details.append("reversal_flag", 0);

        dispatch(
            createRefundApi(
                details,
                (res) => {
                    // console.log(res)
                    setResponseMsg(res.data.message)
                    setToasterType("success")

                    setApproveRefundLoading(false);
                    GetRefundListViaStatusFn();
                    handleCloseApproveRefundModal();


                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponseMsg(res.data.message)
                    setToasterType("error");

                    setApproveRefundLoading(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    // Functions for the setting the refund amounts
    const [paymentConfigObj, setPaymentConfigObj] = useState({});

    const getPaymentConfigFn = () => {
        let details = {}
        dispatch(
            getPaymentConfigApi(details,
                (res) => {
                    // console.log(res.data.data)
                    // console.log(res?.data?.data)
                    setPaymentConfigObj(res?.data?.data?.purchase);
                },
                (res) => {
                    console.log(res.data.data)
                })
        )
    }

    const searchAreaVal = (e) => {
        // setSearchArea(e.target.value)
        // if (searchArea.trim().length >= 2) {
        //     onChangePage(1)
        // }

        setSearchValue(e.target.value)
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
        }
    }

    const onChangePage = (e, p) => {
        // setPage(p);
        setPage(e);
    };

    const handleChangeRowsPerPage = (e) => {
        // console.log(e)
        setSearchValue("");
        setPage(1);
        setPageSize(e.target.value);
    };

    useEffect(() => {
        // if (searchValue.trim().length > 2) {

        //   const ele = [];
        //   setPage(1);
        //   setElements(ele);

        //   setFlag(true);
        //   const timeOutId = setTimeout(onLoadSearch, 1000);
        //   return () => clearTimeout(timeOutId);
        // } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
        //   if (flag) {
        //     onLoadData();
        //   }
        // }

        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(onLoadSearch, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0) {
            if (flag) {
                onLoadSearch();
            }
        }
    }, [searchValue]);

    const handleColumnName = (name) => {
        setSortingCol(false);
        setColumnName(name);

        if (sortByValue === "ASC") {
            setSortByValue("DESC");
        }
        if (sortByValue === "DESC") {
            setSortByValue("ASC");
        }
    };

    const handleOrderValue = (order) => {
        setSortByValue(order);
    };

    // Format the unix time in given format
    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    return (
        <div>

            <div className="row mx-3 mb-5" style={{}}>
                <div className="col-12 px-0">

                    <div className="row mx-0 p-3">
                        <div className="col-6 px-0 ps-2 d-flex align-item-center justify-content-start">
                            <span className="fs-4 fw-bold text-black">{"Refunds"}</span>
                        </div>


                    </div>

                    <div className='mx-0 row text-black overflow-auto text-nowrap user-profile-nav-bar border-2 border-top border-bottom '>
                        <div className='col-12 px-0 d-flex font-w500 align-items-center my-3'>
                            <div onClick={() => setToggleRefundTabs(1)} className={`${toggleRefundTabs === 1 ? "bg-black" : "bg-light"} ${toggleRefundTabs === 1 && "text-white"} ${toggleRefundTabs === 1 && "font-w600"} cursor-pointer license-type-box me-2 px-3 py-2 rounded-1`}>
                                <span>{"Requests raised"}</span>
                            </div>

                            <div onClick={() => setToggleRefundTabs(2)} className={`${toggleRefundTabs === 2 ? "bg-black" : "bg-light"} ${toggleRefundTabs === 2 && "text-white"} ${toggleRefundTabs === 2 && "font-w600"} cursor-pointer license-type-box me-2 px-3 py-2 rounded-1`}>
                                <span>{"In progress"}</span>
                            </div>

                            <div onClick={() => setToggleRefundTabs(3)} className={`${toggleRefundTabs === 3 ? "bg-black" : "bg-light"} ${toggleRefundTabs === 3 && "text-white"} ${toggleRefundTabs === 3 && "font-w600"} cursor-pointer license-type-box me-2 px-3 py-2 rounded-1`}>
                                <span>{"Completed"}</span>
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 d-flex justify-content-end">
                        <div style={{ width: '250px' }}>
                            <SelectPeriodFilter
                                labelName={`Period`}
                                onChange={(e) => handlePeriodFilter(e)}
                                defaultValue={periodFilter}
                                options={periodArr}
                                errorOccured={false}
                                errorMessage={""}
                            />
                        </div>
                    </div>



                    <div className='mb-3'>
                        <PaginationAndSearching
                            handleSearch={searchAreaVal}
                            // searchValue={searchArea}
                            searchValue={searchValue}
                            defaultValue={pageSize}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            totalCount={totalPage}
                            onChange={onChangePage}
                        />
                    </div>

                    <Table responsive >

                        <thead>
                            <tr className='text-black bg-light'>
                                {toggleRefundTabs === 1 &&
                                    <th
                                        style={{ fontWeight: '700' }}
                                    >
                                        {`Actions`}
                                    </th>
                                }

                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("created_date_dtm") }}
                                >
                                    {`Created on`}
                                    <span className="ml-1">
                                        {columnName === 'created_date_dtm' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>

                                <th
                                    // className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                // onClick={() => { handleColumnName("display_id_int") }}
                                >
                                    {`Service Id`}
                                    {/* <span className="ml-1">
                                        {columnName === 'display_id_int' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span> */}
                                </th>

                                {/* <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("company_name_chr") }}
                                >
                                    {`Created By`}
                                    <span className="ml-1">
                                        {columnName === 'company_name_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th> */}

                                <th
                                    // className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                // onClick={() => { handleColumnName("ein_chr") }}
                                >
                                    {`Description`}
                                    {/* <span className="ml-1">
                                        {columnName === 'ein_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span> */}
                                </th>

                                <th
                                    // className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                // onClick={() => { handleColumnName("company_email_chr") }}
                                >
                                    {`${toggleRefundTabs === 3 ? "Refunded Amount" : "Refund Amount"}`}
                                    {/* <span className="ml-1">
                                        {columnName === 'company_email_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span> */}
                                </th>

                                {/* <th></th> */}
                            </tr>
                        </thead>

                        <tbody>
                            {customeSkeletonLoading ?
                                <SkeletonTableRow
                                    cols={toggleRefundTabs === 1 ? 5 : 4}
                                /> :
                                <>
                                    {elements?.length > 0 ?
                                        <>
                                            {elements?.map((element, index) => {
                                                return (
                                                    <>
                                                        <tr
                                                            className={`notification-rows font-w700 ${isExpandedCallLogId === element.call_log_id_lng ? "bg-primary text-white " : ""}`}
                                                            key={index}
                                                            style={{ cursor: 'default' }}
                                                        // onClick={() => {
                                                        //     if (element?.call_log_id_lng === isExpandedCallLogId) {
                                                        //         setIsExpandedCallLogId('')
                                                        //     } else {
                                                        //         setIsExpandedCallLogId(element.call_log_id_lng)
                                                        //     }
                                                        // }}
                                                        >

                                                            {toggleRefundTabs === 1 &&
                                                                <td className="d-flex align-items-center text-center">
                                                                    <div className="">
                                                                        <div className="tooltipCustom">
                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Approve refund"}</span>
                                                                            <span
                                                                                className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                                                                style={{
                                                                                    height: '35px',
                                                                                    width: '35px',
                                                                                    color: "rgba(45, 204, 99, 1)",
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleOpneApproveRefundModal(element);
                                                                                }}

                                                                            >
                                                                                <i className="bi bi-check-circle-fill"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            }

                                                            {/* <td>
                                                                <div className="d-flex align-items-center">
                                                                    {element?.company_logo_url ? <img
                                                                        src={element?.company_logo_url}
                                                                        className={`rounded-lg me-2 ${element?.call_log_id_lng === isExpandedCallLogId ? "border" : ""} rounded-3`}
                                                                        width="24"
                                                                        height="24"
                                                                        alt=""
                                                                        style={{ objectFit: "contain" }}
                                                                    /> :
                                                                        <i style={{ height: "24px", width: "24px" }} className="bi bi-person-circle fs-4 me-2"></i>
                                                                    }

                                                                    {" "}
                                                                    <span className="w-space-no">{`${element.call_log_id_lng ? element.call_log_id_lng : "-"}`}</span>
                                                                </div>
                                                            </td> */}

                                                            <td>
                                                                {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}

                                                                <span className="">{`${element?.created_date_dtm ?
                                                                    new Intl.DateTimeFormat("en-US", {
                                                                        year: "numeric",
                                                                        month: "short",
                                                                        day: "numeric",
                                                                        hour: 'numeric',
                                                                        minute: 'numeric',
                                                                        hour12: true
                                                                    }).format(
                                                                        element?.created_date_dtm * 1000
                                                                    ) : '-'}`}</span>
                                                            </td>

                                                            <td>
                                                                <span className="">{`${element?.display_id_int ? `#${element?.display_id_int}` : '-'}`}</span>
                                                            </td>

                                                            <td>
                                                                <span
                                                                    className="w-space-no"
                                                                >
                                                                    {`${element?.meta_data?.description ? element?.meta_data?.description : "-"}`}
                                                                </span>
                                                            </td>


                                                            <td>
                                                                <span className="w-space-no">
                                                                    {element?.meta_data?.object == "payment_intent" ? `${USDollar.format(element?.meta_data?.amount / 100)}` : `${USDollar.format(0)}`}
                                                                </span>
                                                            </td>

                                                            {/* <td>
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        if (element?.call_log_id_lng === isExpandedCallLogId) {
                                                                            setIsExpandedCallLogId('')
                                                                        } else {
                                                                            setIsExpandedCallLogId(element.call_log_id_lng)
                                                                        }
                                                                    }}
                                                                    className="d-flex align-items-center justify-content-center bg-light rounded-3 overlay-action-btn text-black"
                                                                    style={{ fontSize: '15px', height: '30px', width: '35px' }}>
                                                                    {element?.call_log_id_lng === isExpandedCallLogId ? <i class="bi bi-chevron-down"></i> : <i class="bi bi-chevron-right"></i>}
                                                                </div>
                                                            </td> */}
                                                        </tr>

                                                        <tr>
                                                            <td colSpan="8" className={`bg-light ${(element?.call_log_id_lng !== isExpandedCallLogId) ? 'p-0' : ''}`}>
                                                                <Collapse
                                                                    in={element?.call_log_id_lng === isExpandedCallLogId}
                                                                >
                                                                    <div className='row mx-0'>
                                                                        <div className='col-12 px-0'>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`EIN`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="">{`${element.ein_chr ? element.ein_chr : "-"}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Company name`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="">{`${element.company_name_chr ? element.company_name_chr : "-"}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Company address`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="" >{element.company_address_chr ? element.company_address_chr : "-"}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Email`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="" >{element.company_email_chr ? element.company_email_chr : "-"}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Phone`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    {/* <span className="" >{!element.company_phone_number_int ? ('-') : <InternationalPhoneFormat countryCode={element.company_phone_code_id_lng} phoneNumber={`${element.company_phone_number_int}`} />}</span> */}
                                                                                    -
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Created on`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}
                                                                                    {/* <span className="">
                                                                                        {new Intl.DateTimeFormat("en-US", {
                                                                                            year: "numeric",
                                                                                            month: "long",
                                                                                            day: "numeric",
                                                                                            hour: "numeric",
                                                                                            minute: "numeric",
                                                                                        }).format(element.created_date_dtm + "000")}
                                                                                    </span> */}

                                                                                    <span className="">{`${element?.created_date_dtm ?
                                                                                        new Intl.DateTimeFormat("en-US", {
                                                                                            year: "numeric",
                                                                                            month: "short",
                                                                                            day: "numeric",
                                                                                            hour: 'numeric',
                                                                                            minute: 'numeric',
                                                                                            hour12: true
                                                                                        }).format(
                                                                                            element?.created_date_dtm * 1000
                                                                                        ) : '-'}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Updated on`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}
                                                                                    <span className="">
                                                                                        {new Intl.DateTimeFormat("en-US", {
                                                                                            year: "numeric",
                                                                                            month: "long",
                                                                                            day: "numeric",
                                                                                            hour: "numeric",
                                                                                            minute: "numeric",
                                                                                        }).format(element.updated_date_dtm + "000")}
                                                                                    </span>
                                                                                </div>
                                                                            </div>


                                                                            {/* <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Status`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className=" font-w600" style={{ color: element?.is_company_verified_ysn ? "rgba(45, 204, 99, 1)" : "rgba(255, 0, 0, 1)" }}>{element?.is_company_verified_ysn ? `Verified` : `Unverified`}</span>
                                        </div>
                                      </div> */}

                                                                        </div>
                                                                    </div>
                                                                </Collapse>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            })}</> :
                                        <tr>
                                            <td colSpan={`${toggleRefundTabs === 1 ? 5 : 4}`}>No Records Found</td>
                                        </tr>
                                    }
                                </>
                            }
                        </tbody>
                    </Table>



                    {/* Users listing */}

                    {false && <div className="overflow-auto">
                        {elements.length > 0 ?
                            <>
                                {elements.map((element, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="row mx-0 my-2  overlay-action-btn "
                                            onClick={(e) => {
                                            }}
                                        >
                                            <div className="col-12 px-0 py-2 border-bottom border-light" style={{}}>
                                                <div className="d-flex">
                                                    <div className="d-flex justify-content-center p-2">
                                                        <span className="bg-light rounded-circle border border-dark border-2 d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>

                                                            <i className="bi bi-person-circle fs-1 mt-1"></i>

                                                        </span>
                                                    </div>

                                                    <div className="d-flex flex-column w-100 px-3 py-2">

                                                        <div className="row mx-0 fs-7 mb-1">
                                                            <div className="col-4 fw-bold text-black">
                                                                <span>{"Created date"}</span>
                                                            </div>
                                                            <div className="col-8 font-w500">
                                                                <span>
                                                                    {new Intl.DateTimeFormat("en-US", {
                                                                        year: "numeric",
                                                                        month: "long",
                                                                        day: "numeric",
                                                                    }).format(element?.created_date_dtm + "000")}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div className="row mx-0 fs-7 mb-1">
                                                            <div className="col-4 fw-bold text-black">
                                                                <span>{"Updated date"}</span>
                                                            </div>
                                                            <div className="col-8 font-w500">
                                                                <span>
                                                                    {new Intl.DateTimeFormat("en-US", {
                                                                        year: "numeric",
                                                                        month: "long",
                                                                        day: "numeric",
                                                                    }).format(element?.updated_date_dtm + "000")}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div className="row mx-0 fs-7 mb-1">
                                                            <div className="col-4 fw-bold text-black">
                                                                <span>{`User Id`}</span>
                                                            </div>
                                                            <div className="col-8 font-w500">
                                                                <span>{`${element?.from_chr}`}</span>
                                                            </div>
                                                        </div>

                                                        <div className="row mx-0 fs-7 mb-1">
                                                            <div className="col-4 fw-bold text-black">
                                                                <span>{`Description`}</span>
                                                            </div>
                                                            <div className="col-8 font-w500">
                                                                <span>{`${element?.meta_data?.description}`}</span>
                                                            </div>
                                                        </div>

                                                        {toggleRefundTabs !== 2 &&
                                                            <div className="row mx-0 fs-7 mb-1">
                                                                <div className="col-4 fw-bold text-black">
                                                                    <span>
                                                                        {toggleRefundTabs === 1 ? `Amount to refund` : toggleRefundTabs === 3 ? `Amount refunded` : ``}
                                                                    </span>
                                                                </div>
                                                                <div className="col-8 fw-bold text-black">
                                                                    <span>
                                                                        {/* {
                                                                            element?.transfer_data?.map((data) => {
                                                                                return (
                                                                                    <>
                                                                                        {data.is_sent_to_pro && `${USDollar.format(((data?.amount / 100) || 0) + ((paymentConfigObj?.service_charge_percentage_float * paymentConfigObj?.call_charge_amount_in_cents_int) / 100))}`}
                                                                                    </>
                                                                                )
                                                                            })
                                                                        } */}
                                                                        {element?.meta_data?.object == "payment_intent" ? `${USDollar.format(element?.meta_data?.amount / 100)}` : 0}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        }




                                                        {toggleRefundTabs === 1 &&
                                                            <div className="row mx-0">
                                                                <div className="col-12 d-flex align-items-center justify-content-end">

                                                                    <button
                                                                        className="me-2 admin-btn-group border-0"
                                                                        style={{ width: 'auto', borderRadius: '4px' }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleOpneApproveRefundModal(element)
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-check2 me-2 text-success fs-4" />
                                                                        {"Approve refund"}
                                                                    </button>

                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </> :
                            <>
                                <div className="row mx-0 mt-5">
                                    <div className="col-12 px-0 text-center">
                                        <span className="fs-6 font-w500">{"No records found"}</span>
                                    </div>
                                </div>
                            </>
                        }
                    </div>}


                </div>
            </div>

            {/* <!-- Modal For the expertise edit/delete/add --> */}
            <>

                <Modal
                    className="fade"
                    show={approveRefundModalTrigger}
                    // onHide={handleClose} 
                    centered
                >

                    <Modal.Body>

                        <div className='row mx-0'>
                            <div className='col-12 px-0'>

                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {`Approve refund`}
                                        </span>
                                    </div>
                                    <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                        <span onClick={() => handleCloseApproveRefundModal()} className='cursor-pointer text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <>
                                    <div className='row mx-0 text-black lh-lg'>
                                        <div className='col-6 px-0 font-w600'>
                                            <span>{`Created date`}</span>
                                        </div>
                                        {(Object?.keys(refundObj)?.length !== 0) &&
                                            <div className='col-6 px-0'>
                                                {/* <span>
                                                    {new Intl.DateTimeFormat("en-US", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                    }).format(refundObj?.created_date_dtm + "000")}
                                                </span> */}

                                                <span className="">{`${refundObj?.created_date_dtm ?
                                                    new Intl.DateTimeFormat("en-US", {
                                                        year: "numeric",
                                                        month: "short",
                                                        day: "numeric",
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        hour12: true
                                                    }).format(
                                                        refundObj?.created_date_dtm * 1000
                                                    ) : '-'}`}</span>

                                            </div>
                                        }
                                    </div>

                                    <div className='row mx-0 text-black lh-lg'>
                                        <div className='col-6 px-0 font-w600'>
                                            <span>{`User Id`}</span>
                                        </div>
                                        <div className='col-6 px-0'>
                                            <span>{`${refundObj?.from_chr}`}</span>
                                        </div>
                                    </div>



                                    <div className='row mx-0 text-black lh-lg'>
                                        <div className='col-6 px-0 font-w600'>
                                            <span>{`Description`}</span>
                                        </div>
                                        <div className='col-6 px-0'>
                                            <span>{`${refundObj?.meta_data?.description}`}</span>
                                        </div>
                                    </div>

                                    <div className='row mx-0 text-black lh-lg'>
                                        <div className='col-6 px-0 font-w600'>
                                            <span>{`Amount to refund`}</span>
                                        </div>
                                        {(Object?.keys(refundObj)?.length !== 0) &&
                                            <div className='col-6 px-0 font-w800'>
                                                <span>
                                                    {/* {`${USDollar.format((refundObj?.transfer_data[0]?.amount / 100) || 0)}`} */}
                                                    {/* {
                                                        refundObj?.transfer_data?.map((data) => {
                                                            return (
                                                                <>
                                                                    {data.is_sent_to_pro && `${USDollar.format(((data?.amount / 100) || 0) + ((paymentConfigObj?.service_charge_percentage_float * paymentConfigObj?.call_charge_amount_in_cents_int) / 100))}`}
                                                                </>
                                                            )
                                                        })
                                                    } */}
                                                    {refundObj?.meta_data?.object == "payment_intent" ? `${USDollar.format(refundObj?.meta_data?.amount / 100)}` : 0}
                                                </span>
                                            </div>
                                        }
                                    </div>

                                    <div className='row mx-0 text-black mt-4'>
                                        <div className='col-12 px-0 font-w600'>
                                            <PrimaryButton
                                                onClick={(e) => {
                                                    handleApproveRefund();
                                                }}
                                                buttonName={'CONFIRM'}
                                                loadingMessage={'Loading...'}
                                                isLoading={approveRefundLoading}
                                                style={{
                                                    width: '100%',
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </>



                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </>


            {handleToaster && <ResponceToaster toasterType={toasterType} message={responseMsg} />}
        </div>
    );
};

export default Refunds;
